import { useCallback, useEffect, useState } from 'react';
import { fetchEnquiries } from '../api/enquiries';

export function useEnquiries({ page, pageSize, status, sort, from, to } = {}) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [reloadIndex, setReloadIndex] = useState(0);

    useEffect(() => {
        let cancelled = false;

        setLoading(true);
        setError(null);

        fetchEnquiries({ page, pageSize, status, sort, from, to })
            .then((result) => { if (!cancelled) setData(result); })
            .catch((err) => { if (!cancelled) setError(err); })
            .finally(() => { if (!cancelled) setLoading(false); });

        return () => { cancelled = true; };

    }, [reloadIndex, page, pageSize, status, sort, from, to]);

    const reload = useCallback(() => setReloadIndex((index) => index + 1), []);

    return { data, loading, error, reload };
}
